<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M10.5427 2C11.3316 2 12.0882 2.31338 12.646 2.87121L21.1288 11.354C22.2904 12.5156 22.2904 14.3989 21.1288 15.5605L15.5605 21.1288C14.3989 22.2904 12.5156 22.2904 11.354 21.1288L2.87121 12.646C2.31338 12.0882 2 11.3316 2 10.5427V4.97448C2 3.33172 3.33172 2 4.97448 2H10.5427ZM10.5427 4H4.97448C4.43629 4 4 4.43629 4 4.97448V10.5427C4 10.8012 4.10267 11.049 4.28542 11.2318L12.7682 19.7146C13.1488 20.0951 13.7658 20.0951 14.1463 19.7146L19.7146 14.1463C20.0951 13.7658 20.0951 13.1488 19.7146 12.7682L11.2318 4.28542C11.049 4.10267 10.8012 4 10.5427 4ZM8 6C9.10457 6 10 6.89543 10 8C10 9.10457 9.10457 10 8 10C6.89543 10 6 9.10457 6 8C6 6.89543 6.89543 6 8 6Z"
    fill="currentColor"
  />
</svg>
